import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import messageStore from './message';

const initialState = {
  isGettingCaptcha: false,
  captchaId: null,
  captchaData: null
};

const captchaStore = create((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  createCaptcha: (sessionToken) => {
    set(initialState);
    set({ isGettingCaptcha: true });
    MuvikaService.createCaptcha(sessionToken)
      .then(function (res) {
        console.log("create captcha", res.data)
        if (res.data.error) {
          set({ isGettingCaptcha: false });
        } else {
          set({ captchaId: res.data.data.id, captchaData: res.data.data.image, isGettingCaptcha: false });
        }
      })
      .catch(function () { });
  }
}));

export default captchaStore;